// Entreprise.vue file

<template>
  <div class="entreprise">
    <div class="ban"></div>
    <div class="container">
      <div class="page">
        <!-- DEBUT FIL D'ARIANE -->

        <nav aria-label="Breadcrumb" class="breadcrumb">
          <ul>
            <li>
              <router-link to="/">ACCUEIL</router-link>
            </li>
            <li class="bc-li">
              <span aria-current="page" class="current-page">L'ENTREPRISE BOAS</span>
            </li>
          </ul>
        </nav>

        <!-- FIN FIL D'ARIANE -->
        <h1>Présentation de l'entreprise</h1>
        <div class="e-presentation">
          <div class="e-txt">
            <p class="first">
              <b>
                L’entreprise Boas créée en 1994 est spécialisée dans l’électricité
                bâtiment, le tertiaire, la climatisation et le photovoltaïque.
              </b>
            </p>
            <p>
              Basée à Gimont zone Lafourcade, notre équipe est à votre
              service pour réaliser tous travaux d’électricité, de chauffage et
              de climatisation.
            </p>
            <p>
              Une entreprise avec de
              <b>nombreuses références :</b>
            </p>
            <ul>
              <li>
                <b>Dans l’électricité bâtiment :</b> logements collectifs (Le toit familial), maisons individuelles
              </li>
              <li>
                <b>Dans le tertiaire :</b> mairies (Simorre, Endoufielle...), salles des fêtes (Endoufielle, Frégouville, Pompiac), bureaux Communauté des communes Arrats Gimone, cabinet comptable à Gimont, Agence Immobilière Isle Jourdain, bâtiment industriel à Pujaudran
              </li>
              <li>
                <b>Dans l'économie locale :</b> installations agricoles (chaînes d'aliment, stockage, alimentation moteurs/pompes...), entreprises (Latécoère, imprimerie BCR, Midi patisserie ...)
              </li>
              <li>
                <b>Dans le photovoltaïque :</b> + de 20 références dont toiture de l'église à Maurens, hangar agricole à Frégouville, maisons individuelles à Gimont, Samatan, Escorneboeuf...
              </li>
              <li>
                <b>Dans la climatisation et les pompes à chaleurs :</b> de nombreuses références dans le secteur de Gimont, Samatan, L'Isle-Jourdain, Mauvezin
              </li>
            </ul>
            <p>
              Une entreprise
              <b>engagée dans les énergies renouvelables :</b>
              photovoltaïque, pompe à chaleur...
            </p>
            <p>
              Une entreprise
              <b>respectueuse de l’environnement</b>(traitement des
              déchets, recyclage photovoltaïque Pv Cycle)
            </p>
            <p>
              Une
              <b>entreprise RGE</b> avec des qualifications QualiPV , Quali Pac.
            </p>
            <div class="qualifications">
              <a
                href="https://www.les-energies-renouvelables.eu/conseils/tout-savoir-sur-la-qualification-rge-reconnu-garant-environnement/quest-ce-que-le-label-rge/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="../assets/img/Qualifications/label_rge_r2_c2.png" alt="Label RGE" />
              </a>

              <a
                href="https://www.qualit-enr.org/particuliers/informer-qualif/decouvrez-qualipv"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/img/Qualifications/10073_logo-QualiPV-2022-RGE.jpg"
                  alt="Qualification QualiPV"
                />
              </a>

              <a href="https://www.pvcycle.fr/" target="_blank" rel="noopener noreferrer">
                <img src="../assets/img/Qualifications/PV-CYCLE.png" alt="Qualification PV Cycle" />
              </a>

              <a
                href="https://www.qualit-enr.org/particuliers/informer-qualif/decouvrez-qualipac"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/img/Qualifications/10094_logo-QualiPAC-2022-RGE.jpg"
                  alt="Qualification QualiPAC"
                />
              </a>

              <a
                href="http://docdif.fr.grpleg.com/general/ouidoo/pdf/legrand-my-home-up-domotique.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/img/Qualifications/mini_4073100852_85_partenaire-legrand-my-home_r2_c2.png"
                  alt="Qualification Legrand My Home"
                />
              </a>
            </div>
          </div>
          <div class="e-img">
            <img
              src="../assets/img/entreprise-boas.jpg"
              alt="Façade des locaux de l'entreprise BOAS"
            />
          </div>
        </div>
        <div class="partenaires">
          <h2>Nos partenaires</h2>
          <div class="p-logos">
            <div class="logo legrand">
              <a href="https://www.legrand.fr/" target="_blank" rel="noopener noreferrer">
                <img
                  src="../assets/img/Partenaires/logo-legrand.png"
                  alt="Logo cliquable Legrand entreprise"
                />
              </a>
            </div>
            <div class="logo hager">
              <a href="https://hager.com/fr" target="_blank" rel="noopener noreferrer">
                <img
                  src="../assets/img/Partenaires/logo_hager.png"
                  alt="Logo cliquable Hager entreprise"
                />
              </a>
            </div>
            <div class="logo atlantic">
              <a href="https://www.atlantic.fr/" target="_blank" rel="noopener noreferrer">
                <img
                  src="../assets/img/Partenaires/logo-athlantic.png"
                  alt="Logo cliquable Athlantic entreprise"
                />
              </a>
            </div>
            <div class="logo deltadore">
              <a href="https://www.deltadore.fr/" target="_blank" rel="noopener noreferrer">
                <img
                  src="../assets/img/Partenaires/logo-delta_dore_.png"
                  alt="Logo cliquable Delta Doré entreprise"
                />
              </a>
            </div>
            <div class="logo mitsubishi">
              <a
                href="https://confort.mitsubishielectric.fr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="../assets/img/Partenaires/Mitsubishi_Electric_logo.svg.png"
                  alt="Logo cliquable Mitsubishi Electric entreprise"
                />
              </a>
            </div>
            <div class="logo schneider">
              <a href="https://www.se.com/fr/fr/" target="_blank" rel="noopener noreferrer">
                <img
                  src="../assets/img/Partenaires/logo-schneider-electric.png"
                  alt="Logo cliquable Schneider Electric entreprise"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { titleMixin } from "../mixins/titleMixin";

export default {
  metaInfo: {
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "Entreprise RGE avec de nombreuses références dans l'électricité et le bâtiment ainsi que dans le tertiaire qui est engagée dans les énergies renouvelables et respectueuse de l'environnement à Gimont dans le Gers"
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "RGE, Électricité, Bâtiment, Tertiaire, Énergies renouvelables, Environnement, Gimont, Gers"
      }
    ]
  },
  name: "entreprise",
  mixins: [titleMixin],
  data() {
    return {
      title: "BOAS Électricité générale climatisation photovoltaïque"
    };
  }
};
</script>

<style scoped>
.e-presentation {
  display: flex;
  justify-content: space-between;
}
.first {
  color: rgb(173, 17, 30);
}
.e-txt {
  width: 49%;
}
.entreprise h1 {
  color: rgb(173, 17, 30);
  font-size: 2.4rem;
  margin: 3rem 0 2rem 0;
}
.e-img {
  width: 49%;
}
.e-img img {
  width: 100%;
}
.qualifications {
  display: flex;
  justify-content: space-evenly;
}
.partenaires {
  margin-top: 8rem;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 1rem 0;
  border-radius: 3px;
}
.partenaires h2 {
  color: rgb(173, 17, 30);
}
.p-logos {
  margin-top: 3rem;
  display: flex;
  justify-content: space-evenly;
}
.logo {
  width: 10%;
}
.qualifications a {
  max-width: 100px;
}
.qualifications img,
.logo img {
  width: 100%;
  filter: grayscale(100%);
}
.qualifications img:hover,
.logo img:hover {
  transition: all 0.3s ease-out;
  filter: grayscale(0);
}
.legrand {
  margin-top: -0.2%;
}
.atlantic {
  margin-top: 0.5%;
}

@media all and (max-width: 1200px) {
  .e-presentation {
    display: flex;
    flex-direction: column-reverse;
  }
  .e-txt {
    width: 100%;
  }
  .e-img {
    width: 70%;
  }
  .logo {
    width: 20%;
    padding-right: 2%;
  }
}
@media all and (max-width: 760px) {
  .e-img {
    width: 100%;
  }
  .p-logos {
    display: flex;
    flex-wrap: wrap;
  }
  .logo img {
    filter: grayscale(0%);
  }
}
</style>
